module.exports = __webpack_public_path__ + "img/ValuePlus.3cd7bc32.png";